import ScaleDownDestroy from './behaviors/scale/ScaleDownDestroy.js';
export default ScaleDownDestroy;